import apiCall from "../utils/apiCall";
import {  ElectionResponse,ElectionGuidelineResponse, ElectablePositionResponse, ForgotPasswordPayload, NewElectionGuidelineResponse, EmailTemplateResponse } from "./types";



const statusData = [
    { value: "", label: "Select Status" },
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
  ];


export const statusOptions: any = statusData.map((stat, index) => (
    <option value={stat?.value} key={index}>
      {stat?.label}
    </option>
  ));



 export  const getElectionPeriodCall = async (): Promise<ElectionResponse> => {
    return (await apiCall().get("/SetUpVote/GetAllAnnualElectionSetUp"))?.data;
  };

 

  export const getEventsCall = async () => {
    return (await apiCall().get("/SetUpVote/GetAllActivitySetUp"))?.data;
  };

  export const getAllNomineesCall = async () => {
    return (await apiCall().get("/SetUpVote/GetAllNomination"))?.data;
  };
 
  export const handleLogOut = () => {
    // resetUser();
    // resetSubSidebar();
    localStorage.removeItem("e-voting-admin-user")
    localStorage.removeItem("show-sub-sidebar")
    // navigate("/");
    window.location.href = "/";
  };

  export const getElectionByIdCall = async (electionId: number) => {
    return (await apiCall().get(`/SetUpVote/GetAnnualElectionSetUpById?Id=${electionId}`))?.data
  }

  export const getElectoralPositionsCall = async() => {
    return (await apiCall().get('/SetUpVote/GetAllElectablePosition'))?.data
  }

  export const getAllCandidatesCall = async () => {
    return (await apiCall().get("/SetUpVote/GetAllCandidate"))?.data;
  };

  export const getAllVotesCall = async () => {
    return (await apiCall().get("/SetUpVote/GetAllVote"))?.data;
  };

  export const getAllMembershipTypesCall = async () => {
    return (await apiCall().get("/MembershipSetUp/member/GetAllMembershipRoute"))?.data;
  };

  export const getAccreditedVotersCall = async () => {
    return (await apiCall().put("/SetUpVote/GetAccreditationReport"))?.data;
  };


  const acceptanceStatusData = [
    { value: "Pending", label: "Pending" },
    { value: "Accepted", label: "Accepted" },
    { value: "Declined", label: "Declined" },
  ];
  export const acceptanceStatusOptions = acceptanceStatusData.map((item, index) => (
    <option key={index} value={item?.value}>
      {item?.label}
    </option>
  ));

  const approvalStatusData = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];
  export const approvalStatusOptions = approvalStatusData.map((item, index) => (
    <option key={index} value={item?.value}>
      {item?.label}
    </option>
  ));

  const genderData = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  export const genderOptions = genderData.map((item, index) => (
    <option value={item?.value} key={index}>
      {item?.label}
    </option>
  ));

  export  const getElectionGuidelinesCall = async (): Promise<ElectionGuidelineResponse> => {
    return (await apiCall().get("/SetUpVote/GetElectionGuideline"))?.data;
  };

  
export const getAllElectablePositionByElectionId =
async (electionId?: number | string): Promise<ElectablePositionResponse> => {
  
  return electionId ? (await apiCall().get(`/SetUpVote/GetElectablePositionByIdName?ElectionId=${electionId}`))?.data : (await apiCall().get(`/SetUpVote/GetElectablePositionByIdName`))?.data
};

export const getAcademicQualificationById = async(membershipId: string) => {
  const encodedMembershipNo = encodeURIComponent(membershipId);
  return (await apiCall().get(`/Member/getacademicbymembershipno?membershipNo=${encodedMembershipNo}&qualificationId=0`))?.data
}

export const getProfessionalQualificationById = async(membershipId: string) => {
  const encodedMembershipNo = encodeURIComponent(membershipId);
  return (await apiCall().get(`/Member/getProfessionalBodybyMembershipNo?membershipNo=${encodedMembershipNo}`))?.data
}

export const logoutIfTokenExpired = (expiryDateString: any) => {
  var currentDate = new Date();
  var expiryDate = new Date(expiryDateString)
  if(currentDate > expiryDate) {
    return true;
  }
  else{
    return false;
  }
}

export const forgotPassword = async(payload: ForgotPasswordPayload) => {
  return (await apiCall().post(`/Vote/ForgotPasswordAsync`, payload))?.data
}


  export  const GetAllEmailTemplate = async (): Promise<EmailTemplateResponse> => {
    return (await apiCall().get("/SetUpVote/member/GetAllEmailTemplate"))?.data;
  };
  export  const GetAllVotingEmailTemplate = async (): Promise<EmailTemplateResponse> => {
    return (await apiCall().get("/SetUpVote/GetEmailTemplatesByEmailType?emailType=evoting"))?.data;
  };

  export const getAllEligibleGuidelines = async() : Promise<NewElectionGuidelineResponse>  =>{
        return (await apiCall().get("/SetUpVote/GetAllEligibleGuidelines"))?.data;
    
  }

